export default __webpack_public_path__ + "static/media/fad-speaker.0583e94f.svg";